import React, { useMemo } from "react";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Divider } from "@material-ui/core";
import { NavLink } from "react-router-dom/cjs/react-router-dom";
import { checkIsActive, checkIsActiveLink, toAbsoluteUrl } from "../../../_helpers";
import { Col, Row } from "react-bootstrap";
import { KorekApp } from "../../../../app/modules/Web/pages/Home/KorekApp";
import { GetLogo, GetLogoBusiness } from "../../../_helpers/GetLogo";
import { shallowEqual, useSelector } from "react-redux";
import { KorekAppBusiness } from "../../../../app/modules/Web/pages/Home/KorekAppBusiness";
import { Check } from "@material-ui/icons";
import { useLocation } from "react-router";
import { FormattedMessage } from "react-intl";

export function FooterBusiness() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();
  const location = useLocation()

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  const getHeaderLogo = () => {
    let result = "logo_white.png";
    if (layoutProps.headerSelfTheme && layoutProps.headerSelfTheme !== "dark") {
      result = "logo_large_1_.png";
    }
    return toAbsoluteUrl(`/media/logos/${result}`);
  };

  const socialMedia = useSelector(
    (state) => state.profileSlice.socialMedia,
    shallowEqual
  );
  return (
    <>
      <KorekAppBusiness />
      
    </>
  );
}
